import React from 'react';
import Map, {MapTypes, ControlPosition} from 'common/components/BetterMap';

const defaultProps = {
  fullscreenControl: false,
  mapTypeControl: false,
  zoomControlOptions: {
    position: ControlPosition.LEFT_BOTTOM,
  },
  streetViewControl: false,
  mapTypes: [MapTypes.LIGHT, MapTypes.SATELLITE],
};

const OndemandMap = (props) => (
  <Map {...(Object.assign({}, defaultProps, props))} />
);

export default OndemandMap;



// WEBPACK FOOTER //
// ./src/ondemand/components/OndemandMap.js